'use client';

import { createContext, useContext } from 'react';
import type { FeatureTogglesType } from './feature-toggles.types';

const FeatureTogglesContext = createContext<FeatureTogglesType>([]);

export const useFeatureTogglesContext = () => useContext(FeatureTogglesContext);

export default FeatureTogglesContext;
